var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAuthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: "px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3ea6ff",
      fillOpacity: 1
    },
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 1c4.96 0 9 4.04 9 9 0 1.422-.34 2.762-.93 3.96-1.53-1.722-3.98-2.89-7.379-3.03A3.995 3.995 0 0 0 12 5a3.995 3.995 0 0 0-.691 7.93c-3.399.14-5.848 1.308-7.38 3.03C3.34 14.763 3 13.423 3 12c0-4.96 4.04-9 9-9zM9 9c0-1.648 1.352-3 3-3s3 1.352 3 3-1.352 3-3 3a3.01 3.01 0 0 1-3-3zm3 12c-3.16 0-5.941-1.64-7.55-4.121 1.562-1.95 4.16-2.98 7.55-2.98 3.39 0 5.988 1.03 7.55 2.98C17.942 19.359 15.16 21 12 21zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAuthIcon);
export default __webpack_public_path__ + "static/media/user_auth_icon.5990454ed334ff644db91a2123331151.svg";
export { ForwardRef as ReactComponent };